"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateBulletsBody = void 0;
const validation_1 = require("@fmtk/validation");
exports.validateBulletsBody = (0, validation_1.properties)({
    transcriptionId: (0, validation_1.optional)((0, validation_1.text)()),
    transcriptText: (0, validation_1.text)(),
});
//# sourceMappingURL=GenerateBulletsBody.js.map